import React from 'react';
import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import { Content, Section, Icon } from './styles';
import messages from './messages';

const PopoverStatusInfo = ({
  etextVersion,
  itemIndex,
  oculusVersion,
  statusMessage,
  bookId,
  copyBookId,
  theme,
  jobId,
}) => (
  <Content>
    <Section> Oculus Version : {etextVersion}</Section>
    {itemIndex === 0 ? <Section> Oculus Status : {oculusVersion || 'Getting Info...'}</Section> : null}
    <Section> CSG Indexing Status : {intl.formatMessage(messages?.[statusMessage] || messages['UNKNOWN'])} </Section>
    <Section onClick={copyBookId(bookId)}> Book ID : {bookId} <Icon fill={theme['color.primary']} icon='copy' /> </Section>
    <Section> Job ID : [{jobId}] </Section>
  </Content>
);

export default PopoverStatusInfo;